import { useApiHelper } from "../../utils/helper/apiHelper";

export const RegistrationService = () => {
  const { post } = useApiHelper();
  const registerUser = async (data: any) => {
    const obj = {
      procName: "RegistrationByPin",
      Para: JSON.stringify(data),
    };

    try {
      const res = await post(import.meta.env.VITE_APP_API_URL + "/ExecuteProcedure", obj);
      return res;
    } catch (err) {
      console.error("Registration API Error", err);
      return null;
    }
  };

      const checkUser = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };

  return { registerUser, checkUser, loading: false };
  
};
